import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cells", "onClick", "onKeyPress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// stateful version of DynamicTable from @atlaskit
import { Fragment } from 'react';
import { elementToForgeDoc } from '../../../../utils/elementToForgeDoc';
export var componentPropsConfig = {
  createAnalyticsEvent: false,
  caption: true,
  defaultPage: true,
  defaultSortKey: true,
  defaultSortOrder: true,
  emptyView: {
    value: 'emptyView ? props.render(elementToForgeDoc(emptyView)) as ReactElement : undefined'
  },
  head: {
    value: 'head ? renderRow(head, props.render): undefined',
    comment: "Rendering each cell's content as one React element"
  },
  highlightedRowIndex: true,
  isFixedSize: true,
  isLoading: true,
  isRankable: true,
  label: true,
  loadingSpinnerSize: true,
  onRankEnd: true,
  onRankStart: true,
  onSetPage: true,
  page: true,
  paginationi18n: true,
  rowsPerPage: true,
  rows: {
    value: 'rows?.map((r) => renderRow(r, props.render))',
    comment: "Rendering each cell's content as one React element"
  },
  sortKey: true,
  sortOrder: true,
  testId: true
};
var renderRow = function renderRow(row, render) {
  // not supporting onClick and onKeyPress to simplify API
  var cells = row.cells,
    onClick = row.onClick,
    onKeyPress = row.onKeyPress,
    rest = _objectWithoutProperties(row, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    cells: cells.map(function (cell) {
      var preRenderedContent = cell.content !== undefined ? /*#__PURE__*/React.createElement(Fragment, {
        key: cell.key
      }, render(elementToForgeDoc(cell.content))) : null;
      return _objectSpread(_objectSpread({}, cell), {}, {
        content: preRenderedContent
      });
    })
  });
};
/**
 * Non working props excluded:
 * isRankingDisabled
 * onPageRowsUpdate
 * onSort
 */

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::8c0e1195b5d33d47b3ae21accbfb6e00>>
 * @codegenId #dynamic-table
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen dynamic-table
 * @codegenParams { "defineOwnType": true }
 * @codegenDependency ../../../../../../../design-system/dynamic-table/src/types.tsx <<SignedSource::fafcade470ef2b7e80f3c9635db61213>>
 * @codegenDependency ../../../../../../../analytics/analytics-next/src/hocs/withAnalyticsEvents.tsx <<SignedSource::912bf75b9266c0c95b2e6bf4d8e3c915>>
 * @codegenDependency ../../../../../../../design-system/dynamic-table/src/internal/helpers.tsx <<SignedSource::03e44bc26756d3fb58d2bbc29f93544e>>
 * @codegenDependency ../../../../../../../design-system/dynamic-table/src/components/stateless.tsx <<SignedSource::b0e5f38782ba34b478144bcf3923236b>>
 * @codegenDependency ../../../../../../../design-system/dynamic-table/src/components/stateful.tsx <<SignedSource::c6709531b0918cf11b8c7dce12f9325b>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import PlatformDynamicTable from '@atlaskit/dynamic-table';

// Define the type for DynamicTable as DynamicTableProps at the top of this file

/**
 * A dynamic table displays rows of data with built-in pagination, sorting, and re-ordering functionality.
 */
export var DynamicTable = function DynamicTable(props) {
  var _ref = props.forgeDoc.props,
    caption = _ref.caption,
    defaultPage = _ref.defaultPage,
    defaultSortKey = _ref.defaultSortKey,
    defaultSortOrder = _ref.defaultSortOrder,
    emptyView = _ref.emptyView,
    head = _ref.head,
    highlightedRowIndex = _ref.highlightedRowIndex,
    isFixedSize = _ref.isFixedSize,
    isLoading = _ref.isLoading,
    isRankable = _ref.isRankable,
    label = _ref.label,
    loadingSpinnerSize = _ref.loadingSpinnerSize,
    onRankEnd = _ref.onRankEnd,
    onRankStart = _ref.onRankStart,
    onSetPage = _ref.onSetPage,
    page = _ref.page,
    paginationi18n = _ref.paginationi18n,
    rowsPerPage = _ref.rowsPerPage,
    rows = _ref.rows,
    sortKey = _ref.sortKey,
    sortOrder = _ref.sortOrder,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(PlatformDynamicTable, {
    caption: caption,
    defaultPage: defaultPage,
    defaultSortKey: defaultSortKey,
    defaultSortOrder: defaultSortOrder,
    emptyView: emptyView ? props.render(elementToForgeDoc(emptyView)) : undefined
    // Rendering each cell's content as one React element
    ,
    head: head ? renderRow(head, props.render) : undefined,
    highlightedRowIndex: highlightedRowIndex,
    isFixedSize: isFixedSize,
    isLoading: isLoading,
    isRankable: isRankable,
    label: label,
    loadingSpinnerSize: loadingSpinnerSize,
    onRankEnd: onRankEnd,
    onRankStart: onRankStart,
    onSetPage: onSetPage,
    page: page,
    paginationi18n: paginationi18n,
    rowsPerPage: rowsPerPage
    // Rendering each cell's content as one React element
    ,
    rows: rows === null || rows === void 0 ? void 0 : rows.map(function (r) {
      return renderRow(r, props.render);
    }),
    sortKey: sortKey,
    sortOrder: sortOrder,
    testId: testId
  });
};
/**
 * @codegenEnd
 */